import { createContext } from "react";

export const ClientesZonasContext = createContext();
export const ClientesZonasFormContext = createContext();
